import styles from './Banner.module.css'
import React, {
  useState,
  useEffect
} from 'react'
import {
  android
} from '../../../Functions/Device'
import {
  stores,
  variables
} from '../../../Variables/Variables'

const target = android()
  ? stores.google
  : null

const Banner = () => {
  const [open, setOpen] = useState(() => {
    if (!target) {
      return false
    }
    try {
      return (window.localStorage.getItem(variables.banner.storage) !== '1')
    } catch {
      return true
    }
  })
  const close = () => {
    setOpen(false)
    try {
      window.localStorage.setItem(variables.banner.storage, '1')
    } catch {}
  }
  useEffect(() => {
    const root = document.documentElement
    if (open) {
      root.style.setProperty('--app-banner-height', variables.banner.height + 'px')
    } else {
      root.style.setProperty('--app-banner-height', '0px')
    }
    return () => {
      root.style.setProperty('--app-banner-height', '0px')
    }
  }, [open])
  if (!open || !target) {
    return null
  }
  return (
    <div className={styles.banner}>
      <button
        type="button"
        onClick={close}
        className={styles.close}
      >
        ×
      </button>
      <img
        alt="Planipo"
        className={styles.icon}
        src={`${process.env.PUBLIC_URL}/mobile.png`}
      />
      <div className={styles.infos}>
        <div className={styles.titre}>
          Planipo
        </div>
        <div className={styles.description}>
          Gestion de planning
        </div>
      </div>
      <a
        href={target}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.action}
      >
        Installer
      </a>
    </div>
  )
}

export default Banner
